import { ADDRESS_ROUTES } from "src/features/address";
import { ONBOARDING_ROUTES } from "src/features/onboarding";
import { WARNINGS_ROUTES } from "src/features/warnings";

export const ROOT_ROUTE = "/";

export const PUBLIC_LIST = [...ONBOARDING_ROUTES];

export const PRIVATE_LIST = [...WARNINGS_ROUTES, ...ADDRESS_ROUTES];
